
import * as cloudfrontRuntime$N2098Z60pR from '/var/www/web/providers/cloudfront.ts'
import * as ipxRuntime$dGgj77QKFJ from '/var/www/web/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 400,
    "md": 800,
    "lg": 1200,
    "xl": 1920,
    "xxl": 2100,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudfront']: { provider: cloudfrontRuntime$N2098Z60pR, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$dGgj77QKFJ, defaults: {} }
}
        